<div *ngIf="product" class="wrap">
  <div class="header">
    <div class="title">{{ product.name }}</div>
    <div (click)="onClose()" class="close-btn">
      <app-svg-icon [name]="'close'"></app-svg-icon>
    </div>
  </div>
  <div class="description">
    <div class="title">{{ "@common.description" | translate }}</div>
    <div class="text">{{ product.description }}</div>
  </div>
  <div class="toggler">
    <div
      class="toggler-item"
      [class.active]="toggledItem === 'ingredients'"
      (click)="onToggle('ingredients')"
    >
      {{ "@components.productDescription.toggler.ingredients" | translate }}
    </div>
    <div
      class="toggler-item"
      [class.active]="toggledItem === 'allergens'"
      (click)="onToggle('allergens')"
    >
      {{ "@components.productDescription.toggler.allergens" | translate }}
    </div>
  </div>
  <div class="toggled-content">
    <div
      [class.visible]="toggledItem === 'ingredients'"
      class="toggled-content-item"
    >
      <li *ngFor="let ingredient of product.ingredients">{{ ingredient }}</li>
    </div>
    <div
      [class.visible]="toggledItem === 'allergens'"
      class="toggled-content-item"
    >
      <li *ngFor="let allergen of product.allergens">{{ allergen }}</li>
    </div>
  </div>
</div>
